import axios from 'axios';

// The Odds API configuration
const ODDS_API_KEY = process.env.REACT_APP_ODDS_API_KEY || 'your-api-key-here';

// Use Netlify function proxy to avoid CORS issues
const NETLIFY_SITE_URL = process.env.REACT_APP_NETLIFY_SITE_URL || 'https://bettoradvantage.com';

const ODDS_API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/.netlify/functions/odds-api'
  : 'http://localhost:8888/.netlify/functions/odds-api'; // Local netlify dev

// Fallback URLs for different environments
const FALLBACK_URLS = [
  ODDS_API_BASE_URL,
  'http://localhost:8888/.netlify/functions/odds-api', // Local netlify dev
  `${NETLIFY_SITE_URL}/.netlify/functions/odds-api` // Production netlify function
];

const DIRECT_API_BASE_URL = 'https://api.the-odds-api.com/v4';

// Sample/mock data for development when API key is not available
const MOCK_ODDS_DATA = [
  {
    id: 'mock_game_1',
    sport_key: 'americanfootball_nfl',
    sport_title: 'NFL',
    commence_time: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
    home_team: 'Kansas City Chiefs',
    away_team: 'Buffalo Bills',
    bookmakers: [
      {
        key: 'draftkings',
        title: 'DraftKings',
        last_update: new Date().toISOString(),
        link: 'https://sportsbook.draftkings.com/leagues/football/nfl',
        sid: 'dk123456',
        markets: [
          {
            key: 'h2h',
            link: 'https://sportsbook.draftkings.com/markets/football/nfl/game123',
            sid: 'market123',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -110,
                link: 'https://sportsbook.draftkings.com/betslip?selection=chiefs_win_123',
                sid: 'outcome_chiefs_123'
              },
              { 
                name: 'Buffalo Bills', 
                price: +105,
                link: 'https://sportsbook.draftkings.com/betslip?selection=bills_win_123',
                sid: 'outcome_bills_123'
              }
            ]
          },
          {
            key: 'spreads',
            link: 'https://sportsbook.draftkings.com/markets/football/nfl/game123/spreads',
            sid: 'spread123',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -110,
                point: -3.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=chiefs_spread_123',
                sid: 'outcome_chiefs_spread_123'
              },
              { 
                name: 'Buffalo Bills', 
                price: -110,
                point: 3.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=bills_spread_123',
                sid: 'outcome_bills_spread_123'
              }
            ]
          },
          {
            key: 'totals',
            link: 'https://sportsbook.draftkings.com/markets/football/nfl/game123/totals',
            sid: 'total123',
            outcomes: [
              { 
                name: 'Over', 
                price: -105,
                point: 47.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=over_total_123',
                sid: 'outcome_over_123'
              },
              { 
                name: 'Under', 
                price: -115,
                point: 47.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=under_total_123',
                sid: 'outcome_under_123'
              }
            ]
          },
          {
            key: 'h2h_h1',
            link: 'https://sportsbook.draftkings.com/markets/football/nfl/game123/h2h_h1',
            sid: 'h2h_h1_123',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -120,
                link: 'https://sportsbook.draftkings.com/betslip?selection=chiefs_h1_123',
                sid: 'outcome_chiefs_h1_123'
              },
              { 
                name: 'Buffalo Bills', 
                price: +100,
                link: 'https://sportsbook.draftkings.com/betslip?selection=bills_h1_123',
                sid: 'outcome_bills_h1_123'
              }
            ]
          },
          {
            key: 'h2h_h2',
            link: 'https://sportsbook.draftkings.com/markets/football/nfl/game123/h2h_h2',
            sid: 'h2h_h2_123',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -105,
                link: 'https://sportsbook.draftkings.com/betslip?selection=chiefs_h2_123',
                sid: 'outcome_chiefs_h2_123'
              },
              { 
                name: 'Buffalo Bills', 
                price: -115,
                link: 'https://sportsbook.draftkings.com/betslip?selection=bills_h2_123',
                sid: 'outcome_bills_h2_123'
              }
            ]
          }
        ]
      },
      {
        key: 'fanduel',
        title: 'FanDuel',
        last_update: new Date().toISOString(),
        link: 'https://sportsbook.fanduel.com/football/nfl',
        sid: 'fd789012',
        markets: [
          {
            key: 'h2h',
            link: 'https://sportsbook.fanduel.com/football/nfl/game456',
            sid: 'market456',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -115,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=chiefs789',
                sid: 'chiefs789'
              },
              { 
                name: 'Buffalo Bills', 
                price: +110,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=bills790',
                sid: 'bills790'
              }
            ]
          },
          {
            key: 'spreads',
            link: 'https://sportsbook.fanduel.com/football/nfl/game456/spreads',
            sid: 'spread456',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -105,
                point: -3.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=chiefs_spread789',
                sid: 'chiefs_spread789'
              },
              { 
                name: 'Buffalo Bills', 
                price: -115,
                point: 3.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=bills_spread790',
                sid: 'bills_spread790'
              }
            ]
          },
          {
            key: 'totals',
            link: 'https://sportsbook.fanduel.com/football/nfl/game456/totals',
            sid: 'total456',
            outcomes: [
              { 
                name: 'Over', 
                price: -110,
                point: 47.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=over_total789',
                sid: 'over_total789'
              },
              { 
                name: 'Under', 
                price: -110,
                point: 47.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=under_total790',
                sid: 'under_total790'
              }
            ]
          },
          {
            key: 'h2h_h1',
            link: 'https://sportsbook.fanduel.com/football/nfl/game456/h2h_h1',
            sid: 'h2h_h1_456',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -118,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=chiefs_h1_789',
                sid: 'chiefs_h1_789'
              },
              { 
                name: 'Buffalo Bills', 
                price: +102,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=bills_h1_790',
                sid: 'bills_h1_790'
              }
            ]
          },
          {
            key: 'h2h_h2',
            link: 'https://sportsbook.fanduel.com/football/nfl/game456/h2h_h2',
            sid: 'h2h_h2_456',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -108,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=chiefs_h2_789',
                sid: 'chiefs_h2_789'
              },
              { 
                name: 'Buffalo Bills', 
                price: -112,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=456&selectionId=bills_h2_790',
                sid: 'bills_h2_790'
              }
            ]
          }
        ]
      },
      {
        key: 'betmgm',
        title: 'BetMGM',
        last_update: new Date().toISOString(),
        link: 'https://sports.betmgm.com/en/sports/football-11/betting/usa-9/nfl-35',
        sid: 'mgm345678',
        markets: [
          {
            key: 'h2h',
            link: null, // Example of no market-level link
            sid: null,
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -108,
                link: null, // Example of falling back to event link
                sid: 'chiefs_mgm_456'
              },
              { 
                name: 'Buffalo Bills', 
                price: +102,
                link: null,
                sid: 'bills_mgm_457'
              }
            ]
          },
          {
            key: 'spreads',
            link: null,
            sid: null,
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -110,
                point: -3.5,
                link: null,
                sid: 'chiefs_mgm_spread_456'
              },
              { 
                name: 'Buffalo Bills', 
                price: -110,
                point: 3.5,
                link: null,
                sid: 'bills_mgm_spread_457'
              }
            ]
          },
          {
            key: 'totals',
            link: null,
            sid: null,
            outcomes: [
              { 
                name: 'Over', 
                price: -110,
                point: 47.5,
                link: null,
                sid: 'over_mgm_456'
              },
              { 
                name: 'Under', 
                price: -110,
                point: 47.5,
                link: null,
                sid: 'under_mgm_457'
              }
            ]
          },
          {
            key: 'h2h_h1',
            link: null,
            sid: null,
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -115,
                link: null,
                sid: 'chiefs_mgm_h1_456'
              },
              { 
                name: 'Buffalo Bills', 
                price: -105,
                link: null,
                sid: 'bills_mgm_h1_457'
              }
            ]
          },
          {
            key: 'h2h_h2',
            link: null,
            sid: null,
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -102,
                link: null,
                sid: 'chiefs_mgm_h2_456'
              },
              { 
                name: 'Buffalo Bills', 
                price: -118,
                link: null,
                sid: 'bills_mgm_h2_457'
              }
            ]
          }
        ]
      },
      {
        key: 'fanatics',
        title: 'Fanatics',
        last_update: new Date().toISOString(),
        link: 'https://www.fanaticssportsbook.com/sports/football/nfl',
        sid: 'fanatics123456',
        markets: [
          {
            key: 'h2h',
            link: 'https://www.fanaticssportsbook.com/sports/football/nfl/game123',
            sid: 'fanatics_market123',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -112,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=chiefs_win_123',
                sid: 'fanatics_chiefs_123'
              },
              { 
                name: 'Buffalo Bills', 
                price: +108,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=bills_win_123',
                sid: 'fanatics_bills_123'
              }
            ]
          },
          {
            key: 'spreads',
            link: 'https://www.fanaticssportsbook.com/sports/football/nfl/game123/spreads',
            sid: 'fanatics_spread123',
            outcomes: [
              { 
                name: 'Kansas City Chiefs', 
                price: -115,
                point: -3.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=chiefs_spread_123',
                sid: 'fanatics_chiefs_spread_123'
              },
              { 
                name: 'Buffalo Bills', 
                price: -105,
                point: 3.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=bills_spread_123',
                sid: 'fanatics_bills_spread_123'
              }
            ]
          },
          {
            key: 'totals',
            link: 'https://www.fanaticssportsbook.com/sports/football/nfl/game123/totals',
            sid: 'fanatics_total123',
            outcomes: [
              { 
                name: 'Over', 
                price: -108,
                point: 47.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=over_total_123',
                sid: 'fanatics_over_123'
              },
              { 
                name: 'Under', 
                price: -112,
                point: 47.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=under_total_123',
                sid: 'fanatics_under_123'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'mock_game_2',
    sport_key: 'basketball_nba',
    sport_title: 'NBA',
    commence_time: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    home_team: 'Los Angeles Lakers',
    away_team: 'Boston Celtics',
    bookmakers: [
      {
        key: 'draftkings',
        title: 'DraftKings',
        last_update: new Date().toISOString(),
        link: 'https://sportsbook.draftkings.com/leagues/basketball/nba',
        sid: 'dk_nba_456',
        markets: [
          {
            key: 'h2h',
            link: 'https://sportsbook.draftkings.com/markets/basketball/nba/game789',
            sid: 'market789',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: +120,
                link: 'https://sportsbook.draftkings.com/betslip?selection=lakers_win_789',
                sid: 'outcome_lakers_789'
              },
              { 
                name: 'Boston Celtics', 
                price: -140,
                link: 'https://sportsbook.draftkings.com/betslip?selection=celtics_win_789',
                sid: 'outcome_celtics_789'
              }
            ]
          },
          {
            key: 'spreads',
            link: 'https://sportsbook.draftkings.com/markets/basketball/nba/game789/spreads',
            sid: 'spread789',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: -110,
                point: 2.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=lakers_spread_789',
                sid: 'outcome_lakers_spread_789'
              },
              { 
                name: 'Boston Celtics', 
                price: -110,
                point: -2.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=celtics_spread_789',
                sid: 'outcome_celtics_spread_789'
              }
            ]
          },
          {
            key: 'totals',
            link: 'https://sportsbook.draftkings.com/markets/basketball/nba/game789/totals',
            sid: 'total789',
            outcomes: [
              { 
                name: 'Over', 
                price: -105,
                point: 224.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=over_total_789',
                sid: 'outcome_over_789'
              },
              { 
                name: 'Under', 
                price: -115,
                point: 224.5,
                link: 'https://sportsbook.draftkings.com/betslip?selection=under_total_789',
                sid: 'outcome_under_789'
              }
            ]
          },
          {
            key: 'h2h_h1',
            link: 'https://sportsbook.draftkings.com/markets/basketball/nba/game789/h2h_h1',
            sid: 'h2h_h1_789',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: +110,
                link: 'https://sportsbook.draftkings.com/betslip?selection=lakers_h1_789',
                sid: 'outcome_lakers_h1_789'
              },
              { 
                name: 'Boston Celtics', 
                price: -130,
                link: 'https://sportsbook.draftkings.com/betslip?selection=celtics_h1_789',
                sid: 'outcome_celtics_h1_789'
              }
            ]
          },
          {
            key: 'h2h_h2',
            link: 'https://sportsbook.draftkings.com/markets/basketball/nba/game789/h2h_h2',
            sid: 'h2h_h2_789',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: +135,
                link: 'https://sportsbook.draftkings.com/betslip?selection=lakers_h2_789',
                sid: 'outcome_lakers_h2_789'
              },
              { 
                name: 'Boston Celtics', 
                price: -155,
                link: 'https://sportsbook.draftkings.com/betslip?selection=celtics_h2_789',
                sid: 'outcome_celtics_h2_789'
              }
            ]
          }
        ]
      },
      {
        key: 'fanduel',
        title: 'FanDuel',
        last_update: new Date().toISOString(),
        link: 'https://sportsbook.fanduel.com/basketball/nba',
        sid: 'fd_nba_101112',
        markets: [
          {
            key: 'h2h',
            link: 'https://sportsbook.fanduel.com/basketball/nba/game101112',
            sid: 'market101112',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: +115,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=101112&selectionId=lakers1011',
                sid: 'lakers1011'
              },
              { 
                name: 'Boston Celtics', 
                price: -135,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=101112&selectionId=celtics1012',
                sid: 'celtics1012'
              }
            ]
          },
          {
            key: 'spreads',
            link: 'https://sportsbook.fanduel.com/basketball/nba/game101112/spreads',
            sid: 'spread101112',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: -105,
                point: 2.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=101112&selectionId=lakers_spread1011',
                sid: 'lakers_spread1011'
              },
              { 
                name: 'Boston Celtics', 
                price: -115,
                point: -2.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=101112&selectionId=celtics_spread1012',
                sid: 'celtics_spread1012'
              }
            ]
          },
          {
            key: 'totals',
            link: 'https://sportsbook.fanduel.com/basketball/nba/game101112/totals',
            sid: 'total101112',
            outcomes: [
              { 
                name: 'Over', 
                price: -110,
                point: 224.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=101112&selectionId=over_total1011',
                sid: 'over_total1011'
              },
              { 
                name: 'Under', 
                price: -110,
                point: 224.5,
                link: 'https://sportsbook.fanduel.com/addToBetslip?marketId=101112&selectionId=under_total1012',
                sid: 'under_total1012'
              }
            ]
          }
        ]
      },
      {
        key: 'fanatics',
        title: 'Fanatics',
        last_update: new Date().toISOString(),
        link: 'https://www.fanaticssportsbook.com/sports/basketball/nba',
        sid: 'fanatics_nba_456',
        markets: [
          {
            key: 'h2h',
            link: 'https://www.fanaticssportsbook.com/sports/basketball/nba/game789',
            sid: 'fanatics_market789',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: +118,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=lakers_win_789',
                sid: 'fanatics_lakers_789'
              },
              { 
                name: 'Boston Celtics', 
                price: -138,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=celtics_win_789',
                sid: 'fanatics_celtics_789'
              }
            ]
          },
          {
            key: 'spreads',
            link: 'https://www.fanaticssportsbook.com/sports/basketball/nba/game789/spreads',
            sid: 'fanatics_spread789',
            outcomes: [
              { 
                name: 'Los Angeles Lakers', 
                price: -108,
                point: 2.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=lakers_spread_789',
                sid: 'fanatics_lakers_spread_789'
              },
              { 
                name: 'Boston Celtics', 
                price: -112,
                point: -2.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=celtics_spread_789',
                sid: 'fanatics_celtics_spread_789'
              }
            ]
          },
          {
            key: 'totals',
            link: 'https://www.fanaticssportsbook.com/sports/basketball/nba/game789/totals',
            sid: 'fanatics_total789',
            outcomes: [
              { 
                name: 'Over', 
                price: -105,
                point: 224.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=over_total_789',
                sid: 'fanatics_over_789'
              },
              { 
                name: 'Under', 
                price: -115,
                point: 224.5,
                link: 'https://www.fanaticssportsbook.com/betslip?selection=under_total_789',
                sid: 'fanatics_under_789'
              }
            ]
          }
        ]
      }
    ]
  }
];

// Generate mock data for different sports
const generateMockDataForSport = (sportKey, sportTitle) => {
  const teamPairs = {
    'americanfootball_nfl': [
      { home: 'Kansas City Chiefs', away: 'Buffalo Bills' },
      { home: 'Green Bay Packers', away: 'Dallas Cowboys' }
    ],
    'basketball_nba': [
      { home: 'Los Angeles Lakers', away: 'Boston Celtics' },
      { home: 'Golden State Warriors', away: 'Miami Heat' }
    ],
    'baseball_mlb': [
      { home: 'New York Yankees', away: 'Los Angeles Dodgers' },
      { home: 'Houston Astros', away: 'Atlanta Braves' }
    ],
    'icehockey_nhl': [
      { home: 'Pittsburgh Penguins', away: 'Boston Bruins' },
      { home: 'Tampa Bay Lightning', away: 'Colorado Avalanche' }
    ],
    'soccer_epl': [
      { home: 'Manchester City', away: 'Liverpool' },
      { home: 'Arsenal', away: 'Chelsea' }
    ],
    'tennis_atp': [
      { home: 'Novak Djokovic', away: 'Rafael Nadal' },
      { home: 'Carlos Alcaraz', away: 'Daniil Medvedev' }
    ]
  };

  const teams = teamPairs[sportKey] || [
    { home: 'Team A', away: 'Team B' },
    { home: 'Team C', away: 'Team D' }
  ];

  return teams.map((teamPair, index) => ({
    id: `mock_${sportKey}_${index}`,
    sport_key: sportKey,
    sport_title: sportTitle,
    commence_time: new Date(Date.now() + (index + 1) * 24 * 60 * 60 * 1000).toISOString(),
    home_team: teamPair.home,
    away_team: teamPair.away,
    bookmakers: [
      {
        key: 'draftkings',
        title: 'DraftKings',
        last_update: new Date().toISOString(),
        link: `https://sportsbook.draftkings.com/leagues/${sportKey.split('_')[1]}/${sportKey.split('_')[0]}`,
        sid: `dk_${sportKey}_${index}`,
        markets: [
          {
            key: 'h2h',
            link: `https://sportsbook.draftkings.com/markets/${sportKey}/game_${index}`,
            sid: `market_dk_${index}`,
            outcomes: [
              { 
                name: teamPair.home, 
                price: Math.floor(Math.random() * 200) - 150,
                link: `https://sportsbook.draftkings.com/betslip?selection=home_${index}`,
                sid: `home_dk_${index}`
              },
              { 
                name: teamPair.away, 
                price: Math.floor(Math.random() * 200) - 150,
                link: `https://sportsbook.draftkings.com/betslip?selection=away_${index}`,
                sid: `away_dk_${index}`
              }
            ]
          }
        ]
      },
      {
        key: 'fanduel',
        title: 'FanDuel',
        last_update: new Date().toISOString(),
        link: `https://sportsbook.fanduel.com/${sportKey.split('_')[1]}/${sportKey.split('_')[0]}`,
        sid: `fd_${sportKey}_${index}`,
        markets: [
          {
            key: 'h2h',
            link: `https://sportsbook.fanduel.com/${sportKey}/game_${index}`,
            sid: `market_fd_${index}`,
            outcomes: [
              { 
                name: teamPair.home, 
                price: Math.floor(Math.random() * 200) - 150,
                link: `https://sportsbook.fanduel.com/addToBetslip?marketId=${index}&selectionId=home_${index}`,
                sid: `home_fd_${index}`
              },
              { 
                name: teamPair.away, 
                price: Math.floor(Math.random() * 200) - 150,
                link: `https://sportsbook.fanduel.com/addToBetslip?marketId=${index}&selectionId=away_${index}`,
                sid: `away_fd_${index}`
              }
            ]
          }
        ]
      },
      {
        key: 'betmgm',
        title: 'BetMGM',
        last_update: new Date().toISOString(),
        link: `https://sports.betmgm.com/en/sports/${sportKey.replace('_', '-')}`,
        sid: `mgm_${sportKey}_${index}`,
        markets: [
          {
            key: 'h2h',
            link: null, // Example of fallback to event link
            sid: null,
            outcomes: [
              { 
                name: teamPair.home, 
                price: Math.floor(Math.random() * 200) - 150,
                link: null, // Will fallback to event link
                sid: `home_mgm_${index}`
              },
              { 
                name: teamPair.away, 
                price: Math.floor(Math.random() * 200) - 150,
                link: null,
                sid: `away_mgm_${index}`
              }
            ]
          }
        ]
      },
      {
        key: 'fanatics',
        title: 'Fanatics',
        last_update: new Date().toISOString(),
        link: `https://www.fanaticssportsbook.com/sports/${sportKey.replace('_', '/')}`,
        sid: `fanatics_${sportKey}_${index}`,
        markets: [
          {
            key: 'h2h',
            link: `https://www.fanaticssportsbook.com/sports/${sportKey}/game_${index}`,
            sid: `fanatics_market_${index}`,
            outcomes: [
              { 
                name: teamPair.home, 
                price: Math.floor(Math.random() * 200) - 150,
                link: `https://www.fanaticssportsbook.com/betslip?selection=home_${index}`,
                sid: `fanatics_home_${index}`
              },
              { 
                name: teamPair.away, 
                price: Math.floor(Math.random() * 200) - 150,
                link: `https://www.fanaticssportsbook.com/betslip?selection=away_${index}`,
                sid: `fanatics_away_${index}`
              }
            ]
          }
        ]
      }
    ]
  }));
};

// Generate mock live games data
const generateMockLiveGames = () => {
  const liveGames = [
    {
      id: 'live_game_1',
      sport_key: 'basketball_nba',
      sport_title: 'NBA',
      commence_time: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), // Started 2 hours ago
      home_team: 'Los Angeles Lakers',
      away_team: 'Boston Celtics',
      home_score: 89,
      away_score: 92,
      quarter: '3rd Quarter',
      time_remaining: '6:42',
      is_live: true,
      bookmakers: [
        {
          key: 'draftkings',
          title: 'DraftKings',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Los Angeles Lakers', price: +125 },
                { name: 'Boston Celtics', price: -145 }
              ]
            }
          ]
        },
        {
          key: 'fanduel',
          title: 'FanDuel',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Los Angeles Lakers', price: +120 },
                { name: 'Boston Celtics', price: -140 }
              ]
            }
          ]
        },
        {
          key: 'betmgm',
          title: 'BetMGM',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Los Angeles Lakers', price: +118 },
                { name: 'Boston Celtics', price: -138 }
              ]
            }
          ]
        },
        {
          key: 'fanatics',
          title: 'Fanatics',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Los Angeles Lakers', price: +122 },
                { name: 'Boston Celtics', price: -142 }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'live_game_2',
      sport_key: 'americanfootball_nfl',
      sport_title: 'NFL',
      commence_time: new Date(Date.now() - 1.5 * 60 * 60 * 1000).toISOString(), // Started 1.5 hours ago
      home_team: 'Kansas City Chiefs',
      away_team: 'Buffalo Bills',
      home_score: 14,
      away_score: 21,
      quarter: '2nd Quarter',
      time_remaining: '8:15',
      is_live: true,
      bookmakers: [
        {
          key: 'draftkings',
          title: 'DraftKings',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Kansas City Chiefs', price: +105 },
                { name: 'Buffalo Bills', price: -125 }
              ]
            }
          ]
        },
        {
          key: 'fanduel',
          title: 'FanDuel',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Kansas City Chiefs', price: +110 },
                { name: 'Buffalo Bills', price: -130 }
              ]
            }
          ]
        },
        {
          key: 'fanatics',
          title: 'Fanatics',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Kansas City Chiefs', price: +108 },
                { name: 'Buffalo Bills', price: -128 }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'live_game_3',
      sport_key: 'soccer_epl',
      sport_title: 'EPL',
      commence_time: new Date(Date.now() - 0.75 * 60 * 60 * 1000).toISOString(), // Started 45 minutes ago
      home_team: 'Manchester City',
      away_team: 'Liverpool',
      home_score: 1,
      away_score: 1,
      quarter: '2nd Half',
      time_remaining: '28:30',
      is_live: true,
      bookmakers: [
        {
          key: 'draftkings',
          title: 'DraftKings',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Manchester City', price: -110 },
                { name: 'Liverpool', price: +105 },
                { name: 'Draw', price: +250 }
              ]
            }
          ]
        },
        {
          key: 'fanduel',
          title: 'FanDuel',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Manchester City', price: -115 },
                { name: 'Liverpool', price: +110 },
                { name: 'Draw', price: +260 }
              ]
            }
          ]
        },
        {
          key: 'fanatics',
          title: 'Fanatics',
          last_update: new Date().toISOString(),
          markets: [
            {
              key: 'h2h',
              outcomes: [
                { name: 'Manchester City', price: -112 },
                { name: 'Liverpool', price: +108 },
                { name: 'Draw', price: +255 }
              ]
            }
          ]
        }
      ]
    }
  ];

  return liveGames;
};

// Define the allowed sports for the home screen
const HOME_SCREEN_SPORTS = [
  'americanfootball_nfl',    // NFL
  'basketball_nba',          // NBA
  'basketball_ncaab',        // NCAAB
  'mma_mixed_martial_arts',  // MMA
  'icehockey_nhl',           // NHL
  'baseball_mlb',            // MLB
  'basketball_wnba',         // WNBA
  'soccer_usa_mls',          // MLS
  'americanfootball_ncaaf'   // NCAAF
];

export const fetchOdds = async (sport = 'upcoming', region = 'us', markets = 'h2h,spreads,totals') => {
  // Check if we have a valid API key
  if (!ODDS_API_KEY || ODDS_API_KEY === 'your-api-key-here') {
    console.warn('No valid Odds API key found. Using mock data for development.');
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // If requesting upcoming games (for home screen), filter to only allowed sports
    if (sport === 'upcoming') {
      const filteredMockData = MOCK_ODDS_DATA.filter(game => 
        HOME_SCREEN_SPORTS.includes(game.sport_key)
      );
      return filteredMockData;
    }
    
    // If requesting a specific sport, generate mock data for that sport
    if (sport !== 'upcoming') {
      const sportsData = await getSports();
      const sportInfo = sportsData.find(s => s.key === sport);
      if (sportInfo) {
        return generateMockDataForSport(sport, sportInfo.title);
      }
    }
    
    return MOCK_ODDS_DATA;
  }

  // Handle upcoming games (for home screen) by fetching multiple sports
  if (sport === 'upcoming') {
    try {
      const allGames = [];
      
      // Try to fetch odds for each allowed sport
      for (const sportKey of HOME_SCREEN_SPORTS) {
        for (const url of FALLBACK_URLS) {
          try {
            console.log(`Attempting to fetch ${sportKey} odds from: ${url}`);
            const response = await axios.get(`${url}/sports/${sportKey}/odds`, {
              params: {
                regions: region,
                markets: markets,
                oddsFormat: 'american',
                dateFormat: 'iso',
                includeLinks: 'true',
                includeSids: 'true'
              },
              timeout: 10000,
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            });
            
            if (response.data && response.data.length > 0) {
              allGames.push(...response.data);
              console.log(`Successfully fetched ${response.data.length} ${sportKey} games from: ${url}`);
            }
            break; // Success, break inner loop and continue to next sport
          } catch (error) {
            console.warn(`Failed to fetch ${sportKey} from ${url}:`, error.message);
            continue; // Try next URL for this sport
          }
        }
      }
      
      if (allGames.length > 0) {
        return allGames;
      }
      
      // If no games found from API, fall back to filtered mock data
      console.warn('No games found from API, falling back to filtered mock data');
      const filteredMockData = MOCK_ODDS_DATA.filter(game => 
        HOME_SCREEN_SPORTS.includes(game.sport_key)
      );
      return filteredMockData;
      
    } catch (error) {
      console.error('Error fetching upcoming games:', error);
      // Fall back to filtered mock data
      const filteredMockData = MOCK_ODDS_DATA.filter(game => 
        HOME_SCREEN_SPORTS.includes(game.sport_key)
      );
      return filteredMockData;
    }
  }

  // Handle specific sport requests
  const tryFetchFromUrl = async (baseUrl) => {
    try {
      const response = await axios.get(`${baseUrl}/sports/${sport}/odds`, {
        params: {
          regions: region,
          markets: markets,
          oddsFormat: 'american',
          dateFormat: 'iso',
          includeLinks: 'true',
          includeSids: 'true'
        },
        timeout: 10000, // 10 second timeout per attempt
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      console.warn(`Failed to fetch from ${baseUrl}:`, error.message);
      throw error;
    }
  };

  // Try each URL in the fallback list for specific sport
  for (const url of FALLBACK_URLS) {
    try {
      console.log(`Attempting to fetch odds from: ${url}`);
      const data = await tryFetchFromUrl(url);
      console.log(`Successfully fetched odds from: ${url}`);
      return data;
    } catch (error) {
      // Continue to next URL
      continue;
    }
  }

  // If all URLs fail, fall back to mock data
  console.error('All API endpoints failed. Falling back to mock data.');
  console.warn('API request failed, falling back to mock data.');
  
  // If requesting a specific sport, generate mock data for that sport
  if (sport !== 'upcoming') {
    const sportsData = await getSports();
    const sportInfo = sportsData.find(s => s.key === sport);
    if (sportInfo) {
      return generateMockDataForSport(sport, sportInfo.title);
    }
  }
  
  // Fall back to filtered mock data for upcoming games
  const filteredMockData = MOCK_ODDS_DATA.filter(game => 
    HOME_SCREEN_SPORTS.includes(game.sport_key)
  );
  return filteredMockData;
};

// Unfiltered sports list (includes outright/futures keys like
// americanfootball_nfl_super_bowl_winner). getSports() intentionally strips
// every 'winner' key for the sport dropdowns, so futures discovery needs this.
export const getAllSportsRaw = async () => {
  for (const url of FALLBACK_URLS) {
    try {
      const response = await axios.get(`${url}/sports`, { timeout: 10000 });
      if (Array.isArray(response.data) && response.data.length) return response.data;
    } catch (e) {
      // try the next base URL
    }
  }
  return [];
};

export const getSports = async () => {
  // Helper function to filter and sort sports
  const filterAndSortSports = (sports) => {
    // Use a Set for faster lookups (O(1) average)
    const excludedSports = new Set([
      'americanfootball_ncaaf_championship_winner',
      'americanfootball_nfl_super_bowl_winner', 
      'basketball_nba_championship_winner',
      'icehockey_nhl_championship_winner',
      'politics_us_presidential_election_winner',
      'basketball_nba_preseason'
    ]);
    
    // Use a Map for faster priority lookups (O(1))
    const prioritySports = new Map([
      ['americanfootball_nfl', 0],    // NFL
      ['basketball_nba', 1],          // NBA
      ['basketball_ncaab', 2],        // NCAAB
      ['mma_mixed_martial_arts', 3],  // MMA
      ['icehockey_nhl', 4],           // NHL
      ['baseball_mlb', 5],            // MLB
      ['basketball_wnba', 6],         // WNBA
      ['soccer_usa_mls', 7],          // MLS
      ['americanfootball_ncaaf', 8]   // NCAAF
    ]);
    
    // Filter out excluded sports
    const filteredSports = sports.filter(sport => {
      // Check if sport key is in the excluded set or contains excluded patterns
      const isExcluded = 
        excludedSports.has(sport.key) || 
        sport.key.includes('championship_winner') ||
        sport.key.includes('election_winner') ||
        sport.key.includes('winner');
      return !isExcluded;
    });
    
    // Sort sports: priority sports first, then alphabetically by title
    const sortedSports = filteredSports.sort((a, b) => {
      const aPriority = prioritySports.get(a.key);
      const bPriority = prioritySports.get(b.key);
      
      const aIsPriority = aPriority !== undefined;
      const bIsPriority = bPriority !== undefined;

      // If both are priority sports, maintain the priority order
      if (aIsPriority && bIsPriority) {
        return aPriority - bPriority;
      }
      
      // If only 'a' is a priority sport, it comes first
      if (aIsPriority) {
        return -1;
      }
      
      // If only 'b' is a priority sport, it comes first
      if (bIsPriority) {
        return 1;
      }
      
      // If neither is a priority sport, sort alphabetically by title
      return a.title.localeCompare(b.title);
    });
    
    return sortedSports;
  };

  if (!ODDS_API_KEY || ODDS_API_KEY === 'your-api-key-here') {
    // Mock sports data for development
    const mockSports = [
      { key: 'americanfootball_nfl', title: 'NFL', group: 'American Football', description: 'National Football League', has_outrights: false },
      { key: 'americanfootball_ncaaf', title: 'NCAAF', group: 'American Football', description: 'NCAA College Football', has_outrights: false },
      { key: 'basketball_nba', title: 'NBA', group: 'Basketball', description: 'National Basketball Association', has_outrights: false },
      { key: 'basketball_ncaab', title: 'NCAAB', group: 'Basketball', description: 'NCAA College Basketball', has_outrights: false },
      { key: 'basketball_wnba', title: 'WNBA', group: 'Basketball', description: 'Women\'s National Basketball Association', has_outrights: false },
      { key: 'baseball_mlb', title: 'MLB', group: 'Baseball', description: 'Major League Baseball', has_outrights: false },
      { key: 'icehockey_nhl', title: 'NHL', group: 'Ice Hockey', description: 'National Hockey League', has_outrights: false },
      { key: 'soccer_epl', title: 'EPL', group: 'Soccer', description: 'English Premier League', has_outrights: false },
      { key: 'soccer_usa_mls', title: 'MLS', group: 'Soccer', description: 'Major League Soccer', has_outrights: false },
      { key: 'soccer_uefa_champs_league', title: 'UEFA Champions League', group: 'Soccer', description: 'UEFA Champions League', has_outrights: false },
      { key: 'soccer_fifa_world_cup', title: 'FIFA World Cup', group: 'Soccer', description: 'FIFA World Cup', has_outrights: true },
      { key: 'tennis_wta', title: 'WTA', group: 'Tennis', description: 'Women\'s Tennis Association', has_outrights: false },
      { key: 'tennis_atp', title: 'ATP', group: 'Tennis', description: 'Association of Tennis Professionals', has_outrights: false },
      { key: 'golf_pga_championship', title: 'PGA Championship', group: 'Golf', description: 'PGA Championship', has_outrights: true },
      { key: 'mma_mixed_martial_arts', title: 'MMA', group: 'Mixed Martial Arts', description: 'Mixed Martial Arts', has_outrights: false },
      { key: 'motorsport_nascar', title: 'NASCAR', group: 'Motorsports', description: 'NASCAR Cup Series', has_outrights: false },
      // Add some example championship markets to test filtering
      { key: 'americanfootball_nfl_super_bowl_winner', title: 'NFL Super Bowl Winner', group: 'American Football', description: 'NFL Super Bowl Winner', has_outrights: true },
      { key: 'basketball_nba_championship_winner', title: 'NBA Championship Winner', group: 'Basketball', description: 'NBA Championship Winner', has_outrights: true }
    ];
    
    return filterAndSortSports(mockSports);
  }

  try {
    const response = await axios.get(`${ODDS_API_BASE_URL}/sports`, {
      params: {
        // API key is handled by the proxy function
      }
    });

    return filterAndSortSports(response.data);
  } catch (error) {
    console.error('Error fetching sports list:', error);
    throw error;
  }
};

export const fetchLiveGames = async (region = 'us', markets = 'h2h,spreads,totals') => {
  // Check if we have a valid API key
  if (!ODDS_API_KEY || ODDS_API_KEY === 'your-api-key-here') {
    console.warn('No valid Odds API key found. Returning empty list for live games.');
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    return [];
  }

  try {
    // The Odds API doesn't have a specific "live games" endpoint, so we need to:
    // 1. Fetch current odds for major sports
    // 2. Filter for games that are likely happening now based on commence_time
    // 3. Note: Real live status would need additional data sources or premium API features
    
    const sports = ['americanfootball_nfl', 'basketball_nba', 'soccer_epl', 'baseball_mlb'];
    const allGames = [];
    const currentTime = new Date();

    console.log('Fetching live games for current time:', currentTime.toISOString());

    for (const sport of sports) {
      try {
        const response = await axios.get(`${ODDS_API_BASE_URL}/sports/${sport}/odds`, {
          params: {
            regions: region,
            markets: markets,
            oddsFormat: 'american',
            dateFormat: 'iso',
            includeLinks: 'true',
            includeSids: 'true'
          }
        });

        console.log(`Found ${response.data.length} games for ${sport}`);

        // More flexible live game detection
        const potentialLiveGames = response.data.filter(game => {
          const commenceTime = new Date(game.commence_time);
          const timeDiff = currentTime.getTime() - commenceTime.getTime();
          const hoursAgo = timeDiff / (1000 * 60 * 60);
          
          // Consider a game "live" if:
          // - It started within the last 5 hours (covers most sports)
          // - Or it's starting within the next 30 minutes (pre-game betting)
          const isLive = (hoursAgo >= -0.5 && hoursAgo <= 5);
          
          if (isLive) {
            console.log(`Live game found: ${game.home_team} vs ${game.away_team}, commenced: ${commenceTime.toISOString()}, hours ago: ${hoursAgo.toFixed(2)}`);
          }
          
          return isLive;
        });

        // Add mock live data to real games for demonstration
        const enhancedLiveGames = potentialLiveGames.map((game, index) => ({
          ...game,
          // Add mock live game properties
          home_score: Math.floor(Math.random() * 30) + 10,
          away_score: Math.floor(Math.random() * 30) + 10,
          quarter: getRandomGamePeriod(game.sport_key),
          time_remaining: getRandomTimeRemaining(game.sport_key),
          is_live: true
        }));

        allGames.push(...enhancedLiveGames);
      } catch (sportError) {
        console.warn(`Failed to fetch live games for ${sport}:`, sportError);
        continue;
      }
    }

    console.log(`Total live games found: ${allGames.length}`);

    // If no live games found, return an empty array
    if (allGames.length === 0) {
      console.log('No live games found via API.');
      return [];
    }

    return allGames;
  } catch (error) {
    console.error('Error fetching live games from API:', error);
    
    // Fallback to mock data if API fails
    if (error.response?.status === 401) {
      throw new Error('Invalid API key. Please check your The Odds API configuration.');
    } else if (error.response?.status === 429) {
      throw new Error('API rate limit exceeded. Please try again later.');
    } else {
      console.warn('API request failed, returning empty list for live games.');
      return [];
    }
  }
};

// Helper functions for generating realistic live game data
const getRandomGamePeriod = (sportKey) => {
  const periods = {
    'americanfootball_nfl': ['1st Quarter', '2nd Quarter', '3rd Quarter', '4th Quarter'],
    'basketball_nba': ['1st Quarter', '2nd Quarter', '3rd Quarter', '4th Quarter'],
    'soccer_epl': ['1st Half', '2nd Half'],
    'icehockey_nhl': ['1st Period', '2nd Period', '3rd Period'],
    'baseball_mlb': ['Top 1st', 'Bottom 1st', 'Top 2nd', 'Bottom 2nd', 'Top 3rd', 'Bottom 3rd']
  };
  
  const sportPeriods = periods[sportKey] || ['1st Period', '2nd Period'];
  return sportPeriods[Math.floor(Math.random() * sportPeriods.length)];
};

const getRandomTimeRemaining = (sportKey) => {
  const timeFormats = {
    'americanfootball_nfl': () => `${Math.floor(Math.random() * 15)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
    'basketball_nba': () => `${Math.floor(Math.random() * 12)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
    'soccer_epl': () => `${Math.floor(Math.random() * 45) + 1}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
    'icehockey_nhl': () => `${Math.floor(Math.random() * 20)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`,
    'baseball_mlb': () => `${Math.floor(Math.random() * 2) + 1} Out`
  };
  
  const generator = timeFormats[sportKey] || timeFormats['americanfootball_nfl'];
  return generator();
};

// Utility function to get the best deep link following The Odds API's fallback logic
export const getBestDeepLink = (outcome, market, bookmaker) => {
  // Default bookmaker homepage URLs for fallback
  const bookmakerHomepages = {
    'draftkings': 'https://sportsbook.draftkings.com',
    'fanduel': 'https://sportsbook.fanduel.com',
    'betmgm': 'https://sports.betmgm.com',
    'caesars': 'https://www.caesars.com/sportsbook',
    'pointsbet': 'https://pointsbet.com',
    'betrivers': 'https://ny.betrivers.com/?page=sportsbook',
    'unibet': 'https://www.unibet.com/betting',
    'barstool': 'https://www.barstoolsportsbook.com',
    'twinspires': 'https://www.twinspires.com/sportsbook',
    'williamhill_us': 'https://www.williamhill.com/us',
    'betus': 'https://www.betus.com.pa/sportsbook',
    'betanysports': 'https://www.betanysports.com',
    'bovada': 'https://www.bovada.lv/sports',
    'mybookie': 'https://mybookie.ag/sportsbook',
    'xbet': 'https://www.xbet.ag/sportsbook',
    'lowvig': 'https://www.lowvig.ag/sports',
    'betonline': 'https://www.betonline.ag/sportsbook',
    'fanatics': 'https://www.fanaticssportsbook.com'
  };

  // Follow The Odds API's recommended fallback logic
  if (outcome && outcome.link) {
    return outcome.link;
  } else if (market && market.link) {
    return market.link;
  } else if (bookmaker && bookmaker.link) {
    return bookmaker.link;
  } else {
    // Fall back on the bookmaker's home page
    return bookmakerHomepages[bookmaker?.key] || 'https://example.com';
  }
};

// Utility function to get link type for analytics/display purposes
export const getLinkType = (outcome, market, bookmaker) => {
  if (outcome && outcome.link) {
    return 'outcome'; // Direct bet slip link
  } else if (market && market.link) {
    return 'market'; // Market-specific page
  } else if (bookmaker && bookmaker.link) {
    return 'event'; // Event-specific page
  } else {
    return 'homepage'; // Bookmaker homepage fallback
  }
};

// Function to enrich odds data with additional period markets (h2h_h1, h2h_h2)
export const enrichOddsWithPeriodMarkets = async (oddsData) => {
  // For now, we'll add mock period markets to existing games
  // In production, you would fetch these from the /events/{eventId}/odds endpoint
  
  if (!Array.isArray(oddsData)) return oddsData;
  
  return oddsData.map(game => {
    const enrichedGame = { ...game };
    
    // Add all period markets to each bookmaker
    enrichedGame.bookmakers = game.bookmakers?.map(bookmaker => {
      const enrichedBookmaker = { ...bookmaker };
      const newMarkets = [...bookmaker.markets];
      
      // Generate spreads_h1 market
      const spreadsMarket = bookmaker.markets?.find(m => m.key === 'spreads');
      if (spreadsMarket && !bookmaker.markets?.some(m => m.key === 'spreads_h1')) {
        const spreadsH1Market = {
          key: 'spreads_h1',
          link: spreadsMarket.link ? spreadsMarket.link.replace('/spreads', '/spreads_h1') : null,
          sid: spreadsMarket.sid ? spreadsMarket.sid + '_h1' : null,
          outcomes: spreadsMarket.outcomes?.map(outcome => ({
            ...outcome,
            price: outcome.price + Math.floor(Math.random() * 10) - 5, // Slight variation
            point: outcome.point ? outcome.point * 0.6 : outcome.point, // Reduce spread for half
            link: outcome.link ? outcome.link.replace('_spread_', '_h1_spread_') : outcome.link,
            sid: outcome.sid ? outcome.sid + '_h1' : outcome.sid
          }))
        };
        newMarkets.push(spreadsH1Market);
      }
      
      // Generate totals_h1 market
      const totalsMarket = bookmaker.markets?.find(m => m.key === 'totals');
      if (totalsMarket && !bookmaker.markets?.some(m => m.key === 'totals_h1')) {
        const totalsH1Market = {
          key: 'totals_h1',
          link: totalsMarket.link ? totalsMarket.link.replace('/totals', '/totals_h1') : null,
          sid: totalsMarket.sid ? totalsMarket.sid + '_h1' : null,
          outcomes: totalsMarket.outcomes?.map(outcome => ({
            ...outcome,
            price: outcome.price + Math.floor(Math.random() * 10) - 5, // Slight variation
            point: outcome.point ? outcome.point * 0.45 : outcome.point, // Reduce total for half
            link: outcome.link ? outcome.link.replace('_total_', '_h1_total_') : outcome.link,
            sid: outcome.sid ? outcome.sid + '_h1' : outcome.sid
          }))
        };
        newMarkets.push(totalsH1Market);
      }
      
      // Generate h2h_h1 market
      const h2hMarket = bookmaker.markets?.find(m => m.key === 'h2h');
      if (h2hMarket && !bookmaker.markets?.some(m => m.key === 'h2h_h1')) {
        const h2hH1Market = {
          key: 'h2h_h1',
          link: h2hMarket.link ? h2hMarket.link.replace('/odds', '/h2h_h1') : null,
          sid: h2hMarket.sid ? h2hMarket.sid + '_h1' : null,
          outcomes: h2hMarket.outcomes?.map(outcome => ({
            ...outcome,
            price: outcome.price + Math.floor(Math.random() * 20) - 10, // Slight variation
            link: outcome.link ? outcome.link.replace('_win_', '_h1_win_') : outcome.link,
            sid: outcome.sid ? outcome.sid + '_h1' : outcome.sid
          }))
        };
        newMarkets.push(h2hH1Market);
      }
      
      // Generate spreads_h2 market
      if (spreadsMarket && !bookmaker.markets?.some(m => m.key === 'spreads_h2')) {
        const spreadsH2Market = {
          key: 'spreads_h2',
          link: spreadsMarket.link ? spreadsMarket.link.replace('/spreads', '/spreads_h2') : null,
          sid: spreadsMarket.sid ? spreadsMarket.sid + '_h2' : null,
          outcomes: spreadsMarket.outcomes?.map(outcome => ({
            ...outcome,
            price: outcome.price + Math.floor(Math.random() * 10) - 5, // Slight variation
            point: outcome.point ? outcome.point * 0.6 : outcome.point, // Reduce spread for half
            link: outcome.link ? outcome.link.replace('_spread_', '_h2_spread_') : outcome.link,
            sid: outcome.sid ? outcome.sid + '_h2' : outcome.sid
          }))
        };
        newMarkets.push(spreadsH2Market);
      }
      
      // Generate totals_h2 market
      if (totalsMarket && !bookmaker.markets?.some(m => m.key === 'totals_h2')) {
        const totalsH2Market = {
          key: 'totals_h2',
          link: totalsMarket.link ? totalsMarket.link.replace('/totals', '/totals_h2') : null,
          sid: totalsMarket.sid ? totalsMarket.sid + '_h2' : null,
          outcomes: totalsMarket.outcomes?.map(outcome => ({
            ...outcome,
            price: outcome.price + Math.floor(Math.random() * 10) - 5, // Slight variation
            point: outcome.point ? outcome.point * 0.45 : outcome.point, // Reduce total for half
            link: outcome.link ? outcome.link.replace('_total_', '_h2_total_') : outcome.link,
            sid: outcome.sid ? outcome.sid + '_h2' : outcome.sid
          }))
        };
        newMarkets.push(totalsH2Market);
      }
      
      // Generate h2h_h2 market
      if (h2hMarket && !bookmaker.markets?.some(m => m.key === 'h2h_h2')) {
        const h2hH2Market = {
          key: 'h2h_h2',
          link: h2hMarket.link ? h2hMarket.link.replace('/odds', '/h2h_h2') : null,
          sid: h2hMarket.sid ? h2hMarket.sid + '_h2' : null,
          outcomes: h2hMarket.outcomes?.map(outcome => ({
            ...outcome,
            price: outcome.price + Math.floor(Math.random() * 20) - 10, // Slight variation
            link: outcome.link ? outcome.link.replace('_win_', '_h2_win_') : outcome.link,
            sid: outcome.sid ? outcome.sid + '_h2' : outcome.sid
          }))
        };
        newMarkets.push(h2hH2Market);
      }
      
      enrichedBookmaker.markets = newMarkets;
      
      return enrichedBookmaker;
    });
    
    return enrichedGame;
  });
};

// Function to fetch real period markets for a single game
export const fetchGamePeriodMarkets = async (gameId, sportKey, region = 'us') => {
  const periodMarkets = 'spreads_h1,totals_h1,h2h_h1,spreads_h2,totals_h2,h2h_h2';
  
  // Check if we have a valid API key
  if (!ODDS_API_KEY || ODDS_API_KEY === 'your-api-key-here') {
    console.warn('No valid Odds API key found. Cannot fetch real period markets.');
    return null;
  }

  for (const url of FALLBACK_URLS) {
    try {
      console.log(`Attempting to fetch period markets for ${sportKey} game ${gameId} from: ${url}`);
      const response = await axios.get(`${url}/sports/${sportKey}/events/${gameId}/odds`, {
        params: {
          regions: region,
          markets: periodMarkets,
          oddsFormat: 'american',
          dateFormat: 'iso',
          includeLinks: 'true',
          includeSids: 'true'
        },
        timeout: 15000, // Increased timeout for event-specific requests
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      
      if (response.data) {
        console.log(`Successfully fetched period markets for game ${gameId} from: ${url}`);
        return response.data;
      }
    } catch (error) {
      console.warn(`Failed to fetch period markets for game ${gameId} from ${url}:`, error.message);
      continue; // Try next URL
    }
  }
  
  console.warn(`Failed to fetch period markets for game ${gameId} from all endpoints`);
  return null;
};

// Enhanced function to merge standard odds with period markets (now uses mock data only for initial load)
export const mergeWithRealPeriodMarkets = async (standardOdds, region = 'us') => {
  if (!Array.isArray(standardOdds)) return standardOdds;
  
  console.log(`Adding mock period markets to ${standardOdds.length} games for initial load...`);
  
  // For initial load, just add mock period markets - real data will be fetched on-demand
  const enrichedGames = await enrichOddsWithPeriodMarkets(standardOdds);
  
  console.log(`✅ Added mock period markets to ${enrichedGames.length} games`);
  return enrichedGames;
};

// Cache for storing fetched period market data
const periodMarketCache = new Map();

// Function to fetch real period markets for a specific game on-demand
export const fetchRealPeriodMarketsForGame = async (gameId, sportKey, region = 'us') => {
  const cacheKey = `${gameId}_${region}`;
  
  // Check cache first
  if (periodMarketCache.has(cacheKey)) {
    console.log(`📋 Using cached period markets for game ${gameId}`);
    return periodMarketCache.get(cacheKey);
  }
  
  try {
    console.log(`🔄 Fetching real period markets for game ${gameId}...`);
    const periodData = await fetchGamePeriodMarkets(gameId, sportKey, region);
    
    if (periodData && periodData.bookmakers) {
      // Cache the result
      periodMarketCache.set(cacheKey, periodData);
      console.log(`✅ Real period markets fetched and cached for game ${gameId}`);
      return periodData;
    }
    
    console.log(`⚠️ No real period markets available for game ${gameId}`);
    return null;
  } catch (error) {
    console.error(`❌ Error fetching real period markets for game ${gameId}:`, error.message);
    return null;
  }
};

// Function to merge real period market data into a game's existing data
export const mergeRealPeriodMarketsIntoGame = (game, periodData) => {
  if (!periodData || !periodData.bookmakers || !game.bookmakers) {
    return game;
  }
  
  const mergedGame = { ...game };
  
  mergedGame.bookmakers = game.bookmakers.map(standardBookmaker => {
    const periodBookmaker = periodData.bookmakers.find(
      pb => pb.key === standardBookmaker.key
    );
    
    if (periodBookmaker && periodBookmaker.markets) {
      // Replace mock period markets with real ones
      const nonPeriodMarkets = standardBookmaker.markets.filter(m => 
        !m.key.includes('_h1') && !m.key.includes('_h2')
      );
      
      const realPeriodMarkets = periodBookmaker.markets.filter(pm => 
        pm.key.includes('_h1') || pm.key.includes('_h2')
      );
      
      return {
        ...standardBookmaker,
        markets: [...nonPeriodMarkets, ...realPeriodMarkets]
      };
    }
    
    return standardBookmaker;
  });
  
  return mergedGame;
};

// Enhanced fetchOdds that includes real period markets where available
export const fetchOddsWithPeriodMarkets = async (sport = 'upcoming', region = 'us') => {
  // First fetch the standard markets
  const standardOdds = await fetchOdds(sport, region, 'h2h,spreads,totals');
  
  // Then try to get real period markets, with fallback to mock data
  return await mergeWithRealPeriodMarkets(standardOdds, region);
};

// Fetch list of upcoming events for a sport (used by player props game list)
export const fetchEvents = async (sportKey) => {
  for (const url of FALLBACK_URLS) {
    try {
      const response = await axios.get(`${url}/sports/${sportKey}/events`, {
        timeout: 10000,
        headers: { 'Accept': 'application/json' }
      });
      if (response.data) {
        return response.data;
      }
    } catch (error) {
      console.warn(`fetchEvents failed from ${url}:`, error.message);
    }
  }
  throw new Error(`Failed to fetch events for ${sportKey}`);
};

// Fetch player props for a specific event
export const fetchEventPlayerProps = async (sportKey, eventId, markets) => {
  for (const url of FALLBACK_URLS) {
    try {
      const response = await axios.get(`${url}/sports/${sportKey}/events/${eventId}/odds`, {
        params: {
          regions: 'us',
          markets,
          oddsFormat: 'american',
          bookmakers: 'draftkings,fanduel,caesars,betmgm,fanatics',
        },
        timeout: 15000,
        headers: { 'Accept': 'application/json' }
      });
      if (response.data) {
        return response.data;
      }
    } catch (error) {
      console.warn(`fetchEventPlayerProps failed from ${url}:`, error.message);
    }
  }
  throw new Error(`Failed to fetch player props for event ${eventId}`);
};

// Test function to verify API connectivity
export const testApiConnection = async () => {
  try {
    const response = await axios.get(`${ODDS_API_BASE_URL}/sports`, {
      params: {
        // API key is handled by the proxy function
      },
      timeout: 10000
    });
    console.log('API Connection Test Successful:', response.data);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('API Connection Test Failed:', error);
    return { success: false, error: error.message };
  }
};

// Fetch live and recently completed games WITH scores for one sport
// (The Odds API scores endpoint, via the same proxy fallbacks as the odds calls)
export const fetchScoresForSport = async (sportKey, daysFrom = 3) => {
  for (const url of FALLBACK_URLS) {
    try {
      const response = await axios.get(`${url}/sports/${sportKey}/scores`, {
        params: { daysFrom },
        timeout: 10000,
        headers: { 'Accept': 'application/json' }
      });
      if (response.data) {
        return response.data;
      }
    } catch (error) {
      console.warn(`fetchScoresForSport failed from ${url}:`, error.message);
    }
  }
  throw new Error(`Failed to fetch scores for ${sportKey}`);
};
